import { Modal as AntdModal, ModalProps } from 'antd';
import { defaultProps } from './Modal.type';
import styles from "./Modal.module.scss";
import cx from "classnames";

export const Modal = (props: ModalProps) => {
  const { children, className, ...attributes } = { ...defaultProps, ...props }

  return (
    <AntdModal {...attributes} className={cx(styles.Modal, className)}>
      {children}
    </AntdModal>
  );
};
